import { useEffect, useRef } from "react";

declare global {
  interface Window {
    onYouTubeIframeAPIReady?: () => void;
    YT: typeof YT;
  }
}

let youtubeApiReady = false;
let youtubeApiLoading = false;
let youtubeApiCallbacks: (() => void)[] = [];

const loadYouTubeApi = () => {
  if (!youtubeApiLoading) {
    youtubeApiLoading = true;
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    tag.async = true;
    document.body.appendChild(tag);

    window.onYouTubeIframeAPIReady = () => {
      youtubeApiReady = true;
      youtubeApiCallbacks.forEach((cb) => cb());
      youtubeApiCallbacks = [];
    };
  }
};

export default function YouTubePlayer() {
  const playerRef = useRef<HTMLDivElement>(null);
  const ytPlayer = useRef<YT.Player | null>(null);

  useEffect(() => {
    loadYouTubeApi();

    const onApiReady = () => {
      if (playerRef.current && !ytPlayer.current) {
        ytPlayer.current = new window.YT.Player(playerRef.current, {
          height: "100%",
          width: "100%",
          videoId: "OweWDUN3xDQ", // your fixed video ID
          events: {
            onReady: (event) => {
              event.target.setPlaybackRate(1.25);
            },
          },
        });
      }
    };

    if (youtubeApiReady) {
      // API already ready, create player immediately
      onApiReady();
    } else {
      // Not ready yet, queue the creation
      youtubeApiCallbacks.push(onApiReady);
    }

    return () => {
      if (ytPlayer.current) {
        ytPlayer.current.destroy();
        ytPlayer.current = null;
      }
    };
  }, []);

  return <div style={{ width: "100%", height: "300px" }} ref={playerRef}></div>;
}
